import React, { useState } from 'react';
import { Frame, Icon, Input, SageClassnames, SageTokens, Tooltip } from '@kajabi/sage-react';
import { useCheckout } from '../../../../../checkout/context';

const BusinessVatInput = () => {
  const [showTaxInput, setShowTaxInput] = useState(false);

  const { formParams, handleFormChange, successfulExpressCheckout } = useCheckout();

  if (successfulExpressCheckout) {
    return null;
  }

  return (
    <>
      {localStorage.getItem('ip_country') !== 'US' && (
        <label style={{ display: showTaxInput ? 'none' : 'block' }}>
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <span style={{ textDecoration: 'underline' }} onClick={() => setShowTaxInput(true)}>
            Do you have a tax number?
          </span>
          <Tooltip
            content={
              <div style={{ textAlign: 'left' }}>
                <p
                  className={`${SageClassnames.SPACERS.SM_BOTTOM} ${SageClassnames.TYPE.BODY_SMALL_MED}`}
                >
                  Tax number
                </p>
                <p className={SageClassnames.TYPE.BODY_SMALL}>
                  For certain international jurisdictions adding a valid tax number will remove tax
                  from being charged. Learn more about tax collection here.
                </p>
              </div>
            }
          >
            <Icon icon={SageTokens.ICONS.INFO_CIRCLE} className={SageClassnames.SPACERS.XS_LEFT} />
          </Tooltip>
        </label>
      )}

      {showTaxInput && (
        <Frame>
          <Frame direction={Frame.DIRECTIONS.HORIZONTAL} align={Frame.ALIGNMENTS.START_SPREAD}>
            <label className={SageClassnames.TYPE.BODY_BOLD}>Tax number</label>
            <Tooltip
              content={
                <div style={{ textAlign: 'left' }}>
                  <p
                    className={`${SageClassnames.SPACERS.SM_BOTTOM} ${SageClassnames.TYPE.BODY_SMALL_MED}`}
                  >
                    Tax number
                  </p>
                  <p className={SageClassnames.TYPE.BODY_SMALL}>
                    If you operate in a non-US region and are tax-exempt please add your valid tax
                    number
                  </p>
                </div>
              }
            >
              <Icon
                icon={SageTokens.ICONS.INFO_CIRCLE}
                className={SageClassnames.SPACERS.XS_LEFT}
              />
            </Tooltip>
          </Frame>
          <Input
            id="vat_number"
            className="sage-frame--width-fill"
            label=""
            style={{ marginTop: '-20px' }}
            onChange={handleFormChange}
            placeholder="Enter tax or business number (PST, VAT, GST, etc.)"
            value={formParams.vat_number || ''}
          />
        </Frame>
      )}
    </>
  );
};

export default BusinessVatInput;
